import React from "react";

import { SNETLoader } from "shared/dist/components";
import { useSelector } from "react-redux";

const GlobalLoader = () => {
    const appLoader = useSelector((state) => state.loader.app);

    return (
        <SNETLoader
            isLoading={appLoader.isLoading}
            title={appLoader.title}
            content={appLoader.content}
        />
    );
};

export default GlobalLoader;
